<template>
  <div class="spinner" :style="`width: ${width}px; height: ${width}px`">
    <div
      class="double-bounce1"
      :style="`${fillColor ? 'background-color: ' + fillColor : ''}`"
    ></div>
    <div
      class="double-bounce2"
      :style="`${fillColor ? 'background-color: ' + fillColor : ''}`"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'DotLoader',
  props: {
    width: {
      type: [Number, String],
      required: false,
      default: 50,
    },
    fillColor: {
      type: String,
      required: false,
      default: 'currentColor',
    },
  },
}
</script>

<style>
.spinner {
  width: 40px;
  height: 40px;
  position: relative;
}

.double-bounce1,
.double-bounce2 {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: #333;
  opacity: 0.6;
  position: absolute;
  top: 0;
  left: 0;
  -webkit-animation: sk-bounce 2s infinite ease-in-out;
  animation: sk-bounce 2s infinite ease-in-out;
}

.double-bounce2 {
  -webkit-animation-delay: -1s;
  animation-delay: -1s;
}

@-webkit-keyframes sk-bounce {
  0%,
  100% {
    -webkit-transform: scale(0);
  }
  50% {
    -webkit-transform: scale(1);
  }
}

@keyframes sk-bounce {
  0%,
  100% {
    transform: scale(0);
    -webkit-transform: scale(0);
  }

  50% {
    transform: scale(1);
    -webkit-transform: scale(1);
  }
}
</style>
